'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { useStrictContext } from '@cc-shopping/hooks/useStrictContext';
import { createContext, type PropsWithChildren } from 'react';
import { type ExperimentOfferData, ExperimentOfferProvider } from 'src/shared/providers/ExperimentOfferContext';
import type { MarketplaceEntityWithStatus, RecursiveArg } from './types';
import useMentionedMarketplaceEntities from './useMentionedMarketplaceEntities';
const ReviewContext = createContext<(ReviewCreditCardsPage & {
  mentionedMarketplaceEntities: MarketplaceEntityWithStatus[];
}) | null>(null);
interface ReviewProviderProps extends PropsWithChildren {
  review: ReviewCreditCardsPage;
}
export function ReviewProvider(props) {
  const $ = _c(15);
  const review = props.review;
  const {
    mentionedMarketplaceEntities
  } = useMentionedMarketplaceEntities(review as unknown as RecursiveArg);
  const {
    marketplaceEntity
  } = review;
  let t0;
  if ($[0] !== marketplaceEntity.details.directApplyLink || $[1] !== marketplaceEntity.details.isMonetizing || $[2] !== marketplaceEntity.id || $[3] !== marketplaceEntity.institution || $[4] !== marketplaceEntity.product) {
    t0 = {
      offerId: marketplaceEntity.id,
      isMonetizing: marketplaceEntity.details.isMonetizing,
      directApplyLink: marketplaceEntity.details.directApplyLink,
      institution: marketplaceEntity.institution,
      product: marketplaceEntity.product
    };
    $[0] = marketplaceEntity.details.directApplyLink;
    $[1] = marketplaceEntity.details.isMonetizing;
    $[2] = marketplaceEntity.id;
    $[3] = marketplaceEntity.institution;
    $[4] = marketplaceEntity.product;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const experimentOfferData = t0;
  let t1;
  if ($[6] !== mentionedMarketplaceEntities || $[7] !== review) {
    t1 = {
      ...review,
      mentionedMarketplaceEntities
    };
    $[6] = mentionedMarketplaceEntities;
    $[7] = review;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== props.children || $[10] !== t1) {
    t2 = <ReviewContext.Provider value={t1}>{props.children}</ReviewContext.Provider>;
    $[9] = props.children;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== experimentOfferData || $[13] !== t2) {
    t3 = <ExperimentOfferProvider value={experimentOfferData}>{t2}</ExperimentOfferProvider>;
    $[12] = experimentOfferData;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
ReviewProvider.displayName = 'ReviewProvider';
export const useReviewContext = () => {
  const context = useStrictContext(ReviewContext);
  return context;
};